import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { REGIMEN_QUERY_PARAMS, REGIMEN_TAB_TYPES } from 'client/app/user/user-view/user-regimen/regimen.constants';

/**
 * Pairs with the unguarded `instructions` route entry directly below it in the route table.
 * Returns true only when ?class=OTHERS, dispatching that case to UserViewInstructionsComponent;
 * FACE/HAIR fall through to the next entry (RegimenInstructionComponent).
 */
export const regimenOthersMatch: CanMatchFn = (): boolean => {
  const router = inject(Router);
  const queryParams = router.currentNavigation()?.extractedUrl.queryParams
    ?? router.parseUrl(router.url).queryParams;
  return queryParams[REGIMEN_QUERY_PARAMS.CLASS] === REGIMEN_TAB_TYPES.OTHERS;
};
